import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, AlertTriangle, Info, CheckCircle } from 'lucide-react';

const ConfirmationModal = ({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Aceptar', 
  cancelText = 'Cancelar',
  confirmButtonClass = 'bg-red-600 hover:bg-red-700',
  hideCancelButton = false,
  type = 'warning' // 'warning', 'info', 'success'
}) => {
  if (!isOpen) return null;

  const icons = {
    warning: <AlertTriangle className="w-8 h-8 text-red-600" />,
    info: <Info className="w-8 h-8 text-blue-600" />,
    success: <CheckCircle className="w-8 h-8 text-green-600" />
  };

  const iconBg = {
    warning: 'bg-red-100',
    info: 'bg-blue-100',
    success: 'bg-green-100'
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-50"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative p-8"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="flex flex-col items-center text-center">
            <div className={`w-16 h-16 ${iconBg[type]} rounded-full flex items-center justify-center mb-4`}>
              {icons[type]}
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {title}
            </h2>
            
            <p className="text-gray-600 mb-8">
              {message}
            </p>
          </div>

          <div className="flex items-center justify-center gap-4">
            {!hideCancelButton && (
              <motion.button
                onClick={onCancel}
                className="px-8 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 font-medium rounded-lg transition-colors duration-200 w-full"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                {cancelText}
              </motion.button>
            )}
            <motion.button
              onClick={onConfirm}
              className={`px-8 py-3 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 w-full ${confirmButtonClass}`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {confirmText}
            </motion.button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConfirmationModal;